export default __webpack_public_path__ + "static/media/person2.1d6c3b6d.png";